import { observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

import classNames from "classnames";

import { SpinBox } from "components/UI/SpinBox/SpinBox";
import Icon from "components/UI/IconSVG/Icon";
import ReviewComment from "./ReviewComment/ReviewComment";

import { COMMENT_PLACEHOLDER_TXT } from "./activityRowConstants";

import { useMatchMedia } from "utils/hooks/use-match-media";

import "./ActivityRow.scss";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export const ActivityRow = observer(
  ({
    store,
    activity,
    count,
    editable = true,
    onDown,
    onUp,
    onChange,
    dis,
    linkRef,
    reviewRef,
    commentRef,
  }) => {
    const generatedReviewRef = useRef(null);
    const textareaReviewRef = useRef(null);
    const { isMobile } = useMatchMedia();
    const type = activity.type;
    const query = useQuery();
    const encodedReview = query.get("review-text");
    const [showNotification, setShowNotification] = useState(false);

    const adjustTextareaHeight = () => {
      if (textareaReviewRef.current) {
        textareaReviewRef.current.style.height = 'auto';
        textareaReviewRef.current.style.height = `${textareaReviewRef.current.scrollHeight}px`;
      }
    };

    useEffect(() => {
      if (encodedReview && generatedReviewRef.current) {
        const decodedReview = decodeURIComponent(atob(encodedReview)).trim();
        generatedReviewRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        store.setReviewComment(decodedReview);
        setShowNotification(true);
        setTimeout(adjustTextareaHeight, 0);
      }
    }, [encodedReview, store, generatedReviewRef])

    useEffect(() => {
      adjustTextareaHeight();
    }, [store.reviewComment]);

    return (
      <div className="activity-row__wrapper">
        <div className={classNames("activity-row", count ? "activity-row_disabled" : null, type.startsWith("MAIN") ? "activity-row_solo" : null)}>
          <div className="activity-row__title">
            <Icon className="activity-row__icon" sprite="activities" name={activity.icon} color="#FFE14B" />
            <p>
              {activity.title}
              {activity.titleComment && <span><br />{activity.titleComment}</span>}
            </p>
          </div>
          <SpinBox store={store} activity={activity} count={count} editable={editable} onDown={onDown} onUp={onUp} onChange={onChange} dis={dis} />
        </div>

        {count > 0 &&
          <>
            {type === "MAIN.REVIEW" &&
              <ReviewComment
                store={store}
                reviewRef={reviewRef}
                generatedReviewRef={generatedReviewRef}
                textareaReviewRef={textareaReviewRef}
                showNotification={showNotification}
                setShowNotification={setShowNotification}
                adjustTextareaHeight={adjustTextareaHeight}
                isMobile={isMobile}
              />
            }

            {type === "MAIN.COMMENT" &&
              <div className="textarea__container" ref={commentRef}>
                <textarea
                  minLength={0}
                  maxLength={450}
                  className={`textarea ${store.commentCommentError ? " error" : ""}`}
                  placeholder={COMMENT_PLACEHOLDER_TXT}
                  value={store.commentComment}
                  onChange={(e) => {
                    store.setCommentComment(e.target.value);
                  }}
                />
              </div>
            }
          </>
        }
      </div>
    );
  }
);
